import axios from 'axios'

var qs = require('qs');
var root=window.API_ROOT

//批量添加购物车
export const saveshopping = (params) => {
  return axios.post(root + '/order/shoppingtrolley/save', qs.stringify(params))
}
//立即购买（）
export const sofortkaufen = (params) => {
  return axios.post(root + '/order/shoppingtrolley/sofortkaufen', qs.stringify(params))
}

export const sofortkaufentoken = (params,ssotoken) => {
  return axios.post(root + '/order/shoppingtrolley/sofortkaufen', qs.stringify(params), {ssotoken: ssotoken})
}

//根据groupguid查询数据
export const getFormproperty = (params) => {
  return axios.post(root + '/order/shoppingtrolley/getFormproperty', qs.stringify(params))
}
//修改
export const updateData = (params) => {
  return axios.post(root + '/order/shoppingtrolley/update', qs.stringify(params))
}

export const listShopSub = (params) => {
  return axios.post(root + '/order/shoppingtrolley/listShopSub', qs.stringify(params))
}

//购物车列表
export const listShop = (params) => {
  return axios.get(root + '/order/shoppingtrolley/list', { params: params })
}
//删除购物车商品
export const removeShop = (params) => {
  return axios.post(root + '/order/shoppingtrolley/remove', qs.stringify(params))
}



// WEBPACK FOOTER //
// ./src/api/order/shopping.js